(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DocumoDialogController', DocumoDialogController);

    DocumoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Documo'];

    function DocumoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Documo) {
        var vm = this;

        vm.documo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documo.id !== null) {
                Documo.update(vm.documo, onSaveSuccess, onSaveError);
            } else {
                Documo.save(vm.documo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:documoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
